import { render, staticRenderFns } from "./NoDataList.vue?vue&type=template&id=4e57daa0&scoped=true&"
import script from "./NoDataList.vue?vue&type=script&lang=js&"
export * from "./NoDataList.vue?vue&type=script&lang=js&"
import style0 from "./NoDataList.vue?vue&type=style&index=0&id=4e57daa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57daa0",
  null
  
)

export default component.exports